import { HTMLAttributes, ReactNode } from "react";
import cn from "clsx";

export type BadgeStatus =
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "run"
  | "neutral";

export interface StatusBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  status: BadgeStatus;
  children: ReactNode;
}

const STYLES: Record<BadgeStatus, string> = {
  success: "bg-success-soft text-success",
  warning: "bg-warning-soft text-warning",
  danger: "bg-danger-soft text-danger",
  info: "bg-info-soft text-info",
  run: "bg-run-soft text-run",
  neutral: "bg-surface-3 text-text-2",
};

/** Status-Pille: -soft-Hintergrund + kräftige Textfarbe (Spec §3). */
export function StatusBadge({
  status,
  children,
  className,
  ...rest
}: StatusBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        STYLES[status],
        className
      )}
      {...rest}
    >
      {children}
    </span>
  );
}

export default StatusBadge;
